import { render, staticRenderFns } from "./Stockchart_menu_mobile_bottom.vue?vue&type=template&id=a2109834&scoped=true&"
import script from "./Stockchart_menu_mobile_bottom.vue?vue&type=script&lang=js&"
export * from "./Stockchart_menu_mobile_bottom.vue?vue&type=script&lang=js&"
import style0 from "./Stockchart_menu_mobile_bottom.vue?vue&type=style&index=0&id=a2109834&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2109834",
  null
  
)

export default component.exports